import React, {useEffect, useRef, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, Pagination} from "swiper/modules";

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '../../index.css'
import styles from './AppSwiper.module.scss';
import PromotionItem from "../Promotions/PromotionItem/PromotionItem";
import arrow from '../../constants/images/arrow-for-swiper.svg';
import ModalDiscount from "../ModalDiscount/ModalDiscount";


const AppSwiper = ({promotions = []}) => {
    const [swiper, setSwiper] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPromotion, setSelectedPromotion] = useState(null);
    const appSwiperRef = useRef(null);
    const [appSwiperWidth, setAppSwiperWidth] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handlePrevButtonClick = () => {
        if (swiper) {
            swiper.slidePrev();
        }
    };

    const handleNextButtonClick = () => {
        if (swiper) {
            swiper.slideNext();
        }
    };

    const handleOpenModal = (data) => {
        setIsModalOpen(true);
        setSelectedPromotion(data);
    }

    const data = promotions;

    useEffect(() => {
        const updateWidth = () => {
            if (appSwiperRef.current) {
                setAppSwiperWidth(appSwiperRef.current.getBoundingClientRect().width);
            }

            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', updateWidth);

        return () => window.removeEventListener('resize', updateWidth);
    }, [appSwiperRef]);

    useEffect(() => {
        if (appSwiperRef.current) {
            setAppSwiperWidth(appSwiperRef.current.getBoundingClientRect().width);
        }
    }, []);

    // A single promotion needs no slider/arrows — render it stretched to the
    // full width of the "Акції" section so it reads as intentional.
    if (data.length === 1) {
        return (<div className={styles.appSwiper} ref={appSwiperRef}>
            <div className={styles.singleSlide} onClick={() => handleOpenModal(data[0])}>
                <PromotionItem promotion={data[0]}/>
            </div>

            {isModalOpen &&
                <ModalDiscount closeModal={() => setIsModalOpen(false)} selectedPromotion={selectedPromotion}/>}
        </div>);
    }

    return (<div className={styles.appSwiper} ref={appSwiperRef}>
        <Swiper
            // slidesPerView={appSwiperWidth/(210 + 16) ? appSwiperWidth/(210 + 16) : 1.5}
            slidesPerView={appSwiperWidth ? appSwiperWidth / 210 : 1.5}

            spaceBetween={16}
            onSwiper={(swiper) => {
                setCurrentIndex(swiper.activeIndex);
                setSwiper(swiper);
            }}
            onSlideChange={(swiper) => setCurrentIndex(swiper.activeIndex)}
            modules={[Pagination, Navigation]}
            className="mySwiper"
        >
            {data.map((item, index) => (<SwiperSlide
                onClick={() => handleOpenModal(item)}
                key={item.id ?? index}
            >
                <PromotionItem promotion={item}/>
            </SwiperSlide>))}
        </Swiper>

        {isModalOpen &&
            <ModalDiscount closeModal={() => setIsModalOpen(false)} selectedPromotion={selectedPromotion}/>}

        {windowWidth > 1024 &&
            <>
                <button
                    className={`${styles.button} ${styles.prev}`}
                    style={{display: currentIndex === 0 ? 'none' : 'block'}}
                    onClick={handlePrevButtonClick}
                >
                    <img src={arrow} alt="arrow for swiper to change slide"/>
                </button>
                <button
                    className={`${styles.button} ${styles.next}`}
                    style={{
                        display: currentIndex === data.length - 1 ? 'none' : 'block'
                    }}
                    onClick={handleNextButtonClick}
                >
                    <img src={arrow} alt="arrow for swiper to change slide"/>
                </button>
            </>}
    </div>);
};

export default AppSwiper;
